
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { toggleActiveClassRegion } from "../../../actions/ui";
import Config from "../../../config/main";
import qs from 'qs'

class Prematch extends Component {
    constructor (props) {
        super(props);
        const { fromHomePage } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

        this.state = {
            timeFilter: +fromHomePage ? 999 : 0
        };
        this.setTimeFilter = this.setTimeFilter.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    setTimeFilter (time) {
        return () => {
            if (this.state.timeFilter !== time) {
                this.setState({
                    timeFilter: time
                });
                // On Filter change refreshes SportList and GameWrapper
                const { sportAlias } = this.props.params
                browserHistory.push(`/prematch/${sportAlias}/all/all`)

                return this.props.dispatch(toggleActiveClassRegion(null));
            }
        };
    }

    componentDidUpdate() {
        if ( Config.usaSportCompetitionConfig.includes(this.props.params.sportAlias) && this.state.timeFilter) {
           return this.setState({ timeFilter: 0 });
        }
        return null;
    }

    handleClick () {
        return () => {
            this.props.uiClose("settingSportsbook")();
            this.props.uiClose("betslip")();
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = state => {
    return {
        isAsian: state.terminal.isAsian
    };
};

Prematch.propTypes = {
    uiClose: PropTypes.func,
    routeParams: PropTypes.object
};

export default connect(mapStateToProps)(UIMixin({Component: Prematch}));